import type { RouteLocationRaw } from 'vue-router'

/**
 * Candidate-side path resolver. Returns simple `/<path>` URLs with no
 * siteId prefix and no app/fn query parameters — the candidate site
 * renders resource definitions directly at the path.
 *
 * This provides the same API surface as the admin `useAppRoute` so that
 * shared building-block components can call `useAppRoute().resolve(path)`
 * and get the correct URL for whichever surface they're rendered in.
 */
export function useAppRoute() {
  function resolve(path: string, _options?: { app?: string; fn?: string }): RouteLocationRaw {
    const normalized = path.replace(/^\/+/, '')
    return { path: `/${normalized}` }
  }

  function resolveHref(path: string, _options?: { app?: string; fn?: string }): string {
    const normalized = path.replace(/^\/+/, '')
    return `/${normalized}`
  }

  return { resolve, resolveHref }
}
